import { createAction, props } from '@ngrx/store';
import { HelpDetail } from '../models/help-detail';

export const loadHelpStores = createAction('[HelpStore] Load HelpStores');

export const loadHelpDetails = createAction(
    '[HelpStore] Load HelpDetails',
    props<{ id: number }>()
);

export const loadHelpDetailsSuccess = createAction(
    '[HelpStore] Load HelpDetails Success',
    props<{ data: HelpDetail }>()
);
